<template>
    <app-input v-bind="$props" :value="slug_value" @input="onInput"></app-input>
</template>

<script>
    export default {
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            autocomplete: {
                type: String,
                default: 'off'
            },
            name: String,
            isRequired: {
                type: Boolean,
                default: false
            },
            is_disabled: {
                type: Boolean,
                default: false
            },
            id: String,
            value: String,
            iconState: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: 'text'
            },
            help_link: {
                type: String,
                default: ''
            },
            url: {
                type: String,
                default: ''
            },
            slugify: {
                type: Boolean,
                default: false
            },
        },
        mounted() {
            let $this = this
            let slugSource = this.$parent.$refs.slugSource

            if(slugSource && this.slugify)
                slugSource.$on('input', async function (value) {
                    $this.slug_value = await $this.getSlug(value)
                })
        },
        data(){
            return {
                slug_value: this.value
            }
        },
        methods: {
            onInput(value) {
                this.slug_value = value
                this.$emit('input', value)
            },
            getSlug(value){
                return axios.post(this.url, {string: value}).then(response => response.data)
            }
        }
    }
</script>
